export default __webpack_public_path__ + "static/media/cardown.940aa8ee.png";